"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isNaNDependencies = void 0;

var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var isNaNDependencies = {
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createIsNaN: _factoriesAny.createIsNaN
};
exports.isNaNDependencies = isNaNDependencies;